import { useEffect } from 'react';
import userTeamService from '../services/userTeamService';
import { ensureCommsNotificationPermission } from '../utils/commsNotifications';

/**
 * Request OS notification permission once per session after the first user gesture,
 * when the user has SMS and/or voice calling enabled.
 */
export function useCommsNotificationPermission(user, { voiceAvailable = false, enabled = true } = {}) {
  useEffect(() => {
    if (!enabled || !user?.email || typeof document === 'undefined') return undefined;

    const smsConfig = userTeamService.getUserSmsConfig(user.email);
    const wantsCommsAlerts = voiceAvailable || (smsConfig.smsEnabled && smsConfig.smsNumber);
    if (!wantsCommsAlerts) return undefined;

    let done = false;
    const prompt = () => {
      if (done) return;
      done = true;
      document.removeEventListener('pointerdown', prompt, true);
      ensureCommsNotificationPermission().catch(() => {});
    };

    document.addEventListener('pointerdown', prompt, true);
    return () => {
      done = true;
      document.removeEventListener('pointerdown', prompt, true);
    };
  }, [user?.email, voiceAvailable, enabled]);
}
